import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPedalsOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.58.58a1 1 0 0 0-.707.293 1 1 0 0 0 0 1.414l16.84 16.84a1 1 0 0 0 1.414 0 1 1 0 0 0 0-1.414L2.287.873A1 1 0 0 0 1.58.58m11.477 1.17c-.93 0-1.68.75-1.68 1.682v4.41l8.247 8.246V3.432c0-.931-.75-1.682-1.68-1.682zm-11 5.5c-.93 0-1.68.749-1.68 1.68v7.638c0 .931.75 1.682 1.68 1.682h4.889c.93 0 1.68-.75 1.68-1.682V12.16l-4.91-4.91zm9.32 7.662v1.656c0 .931.75 1.682 1.68 1.682h1.658z" })
});
export default SvgPedalsOff;
